import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import ReactHintFactory from 'react-hint';
import { TIERS } from '../../../common/stores/artist-ratings-constants';

const ReactHint = ReactHintFactory(React);

function getHighlightClass (rating) {
	//TODO: FINALIZE Ranks
	if (rating > 2 && rating < 4) {

		// For ratings of 2 or 3
		return 'warning';
	}

	if (rating > 3) {

		// For ratings of 4
		return 'success';
	}

	// For ratings of 1, 2
	return 'alert';
}

@inject('artistStore')
@observer
class ApprovalMatrix extends React.Component {
	render () {
		const { artistStore } = this.props;

		return (
			<div data-ta="approval-matrix" className="approval-matrix grid-container full">
				<div className="grid-x">
					<div className="cell small-12">
						<div className="grid-x align-justify">
							<div className="cell shrink">
								<h4>Criteria</h4>
							</div>
							<div className="cell shrink padding-right-1">
								<h4>Score</h4>
							</div>
						</div>

						{ this.renderScoreMatrix() }
					</div>

					<div className="cell small-12 padding-top-1">
						<div className="grid-x align-justify">
							<div className="cell shrink">
								<h4>Tier Group: <span style={{color: ([TIERS.TIER_1, TIERS.TIER_2].includes(artistStore.tier) ? '#3adb76' : [TIERS.TIER_3, TIERS.TIER_4, TIERS.TIER_5].includes(artistStore.tier) ? '#ffae00' : '#cc4b37')}}>{ artistStore.tier }</span></h4>
							</div>
							<div className="cell shrink padding-right-1">
								<h4>
									Score Total: <span data-ta="auditionScoreTotal">{ artistStore.totalScore }</span>
								</h4>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderScoreMatrix () {
		const { artistStore } = this.props;
		const scoreMatrix = artistStore.data.artist.get('scoreMatrix') || [];

		return scoreMatrix.map((scoreItem) => {
			return (
				<div 
					data-ta="auditionScoreRow"
					className="grid-x align-middle"
					key={ scoreItem.label }
				>
					<ReactHint events delay={100} />

					<div className="cell small-4">
						<p><strong>{ scoreItem.label }</strong></p>
					</div>

					<div className="cell small-7 text-right">
						<div 
							data-ta="button-group"
							className="small secondary button-group">
							{ this.renderScoreButtons(scoreItem) }
						</div>
					</div>

					<div className="cell small-1 text-right">
						<span className="artist-rating-container"><strong>{ scoreItem.score }</strong></span>
					</div>
				</div>
			);
		});
	}

	renderScoreButtons (scoreItem) {
		const { artistStore } = this.props;
		const { score, label } = scoreItem;

		return artistStore.ratingScale.map((rating, index) => {
			const classList = ['button', 'hollow'];

			if (label == "Catalog Size") {
				const numSongs = artistStore.data.artist.get('songs').length;
				let newScore = 0;
				if (numSongs >= 53) {
					newScore = 4;
				} else if (numSongs < 53 && numSongs >= 27) {
					newScore = 3;
				} else if (numSongs < 27 && numSongs >= 14) {
					newScore = 2;
				} else {
					newScore = 1;
				} 

				this.props.artistStore.setCategoryRating("Catalog Size", window.parseInt(newScore, 10));
				classList.push(newScore === rating ? getHighlightClass(newScore) : 'secondary');
				return (
					<a
						key={ `rating-${rating}` }
						data-ta={ index }
						data-rating={ rating }
						data-category={ label }
						data-rh={ artistStore.getRatingLabel(label, rating) }
						className={ classList.join(' ')}
						// onClick={  }
					>{ rating }</a>
				);
			} 
			classList.push(score === rating ? getHighlightClass(score) : 'secondary');
			return (
				<a
					key={ `rating-${rating}` }
					data-ta={ index }
					data-rating={ rating }
					data-category={ label }
					data-rh={ artistStore.getRatingLabel(label, rating) }
					className={ classList.join(' ')}
					onClick={ this.onClick }>{ rating }</a>
			);
		})
	}

	@autobind
	onClick ({ target }) {
		const { category, rating } = target.dataset;
		this.props.artistStore.setCategoryRating(category, window.parseInt(rating, 10));
	}
}

// Wrap the component to inject dispatch and state into it
export default ApprovalMatrix;
